import { Component, EventEmitter, Inject, Output } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Player, TrackType } from 'fl-player-interface';
import { ResourceVm } from 'qp-ui-interface';
import { LocalStorageKeys } from '../../shared/LocalStorageKeys';
import { NavigationLibraryService } from '../../shared/services/navigation/navigation.service';
import { getAudioTrackList } from '../../shared/utils/PlaybackUtils';
import { LocalStorageService } from '../../shared/services/local-storage/local-storage.service';

export interface Track {
  type: TrackType;
  language: string;
  name: string;
  active: boolean;
}

@Component({
  selector: 'app-player-audio',
  templateUrl: './player-audio-dialog.component.html',
  styleUrls: ['./player-audio-dialog.component.scss'],
})
export class PlayerAudioDialogComponent {
  @Output() closeDialog = new EventEmitter<void>();
  audioTrackList: Track[] = [];

  constructor(
    private localStorage: LocalStorageService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      currentResource: ResourceVm;
      player: Player;
    },
    private navService: NavigationLibraryService
  ) {
    if (this.data.player) {
      this.audioTrackList = getAudioTrackList(this.data.player);
    }
  }

  selectTrack(track: Track): void {
    this.localStorage.setItem(LocalStorageKeys.AUDIO_LANGUAGE, track.language);
    this.data.player.selectTrack(track);
    this.audioTrackList.forEach((audioTrack) => (audioTrack.active = track.language === audioTrack.language));
  }

  /**
   * Go to subtitles container at the right side
   */
  goToSubtitles(): void {
    this.navService.focusContainer('subtitles-vcontainer', false, 0);
    this.navService.setIndexContainer('subtitles-vcontainer', 0);
  }

  /**
   * Handle mouse enter in div to magic remote
   *
   * @param event
   * @param index
   */
  mouseEnter(event: MouseEvent, index: number): void {
    this.navService.focusElement(event.target as HTMLElement, 0, index);
  }

  /**
   * Handle close button event
   */
  close(): void {
    this.closeDialog.emit();
  }
}
